var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60,34H34V30.5A6.508,6.508,0,0,0,27.5,24h-13a2.5,2.5,0,0,1,0-5h33a6.5,6.5,0,0,0,0-13H24v4H47.5a2.5,2.5,0,0,1,0,5h-33a6.5,6.5,0,0,0,0,13h13A2.5,2.5,0,0,1,30,30.5V34H4a2,2,0,0,0-2,2V60a2,2,0,0,0,2,2H60a2,2,0,0,0,2-2V36A2,2,0,0,0,60,34ZM58,58H6V38H58Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 10,
    y: 50
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 10,
    y: 42
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 18,
    y: 42
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 26,
    y: 42
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 34,
    y: 42
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 42,
    y: 42
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 50,
    y: 42
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 18,
    y: 50
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 42,
    y: 50
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 50,
    y: 50
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 12,
    x: 26,
    y: 50
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 16,
    y: 6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.24faeb0ed420db248de1dfe00bc00d27.svg";
export { ForwardRef as ReactComponent };